// @flow
import React, { Component } from "react";

import type { ErrorsType } from "../../types/UserFormType";
import {
  SingleTextField,
  StyledTextField,
  CancelButton,
  SubmitButton
} from "imagus-components";
import {
  ErrosDisplay,
  setErrorMsg,
  checkEmail
} from "../../containers/ErrosDisplay";
import ChipInput from "../../../global/components/ChipInput";

import Grid from "@material-ui/core/Grid";

const DEBOUNCETIME = 500;

type CreateUserFormPropsType = {
  onClose: Function,
  openSnackbar: Function,
  facebaseList: Array<{ [key: string]: * }>,
  companyList: Array<{ [key: string]: * }>,
  groupList: Array<{ [key: string]: * }>,
  user?: { [key: string]: * },
  isImagusAdmin?: boolean,
  isUserAdmin?: boolean,
  createCompanyUser: Function,
  adminUpdateUser: Function
};

type CreateUserFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  facebase_id: string,
  email: string,
  first_name: string,
  last_name: string,
  company_id: string,
  groups: Array<string>
};

const initialform: CreateUserFormStatesType = {
  errors: {},
  loading: false,
  facebase_id: "",
  email: "",
  first_name: "",
  last_name: "",
  company_id: "",
  groups: []
};

class CreateUserForm extends Component<
  CreateUserFormPropsType,
  CreateUserFormStatesType
> {
  timeout: *;
  constructor(props: CreateUserFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = initialform;
  }

  componentDidMount() {
    let initials = { ...initialform };
    if (this.props.user) {
      const user = this.props.user;

      initials.company_id = user.company_id;
      initials.facebase_id = user.facebase_id;
      initials.email = user.email;
      initials.first_name = user.first_name;
      initials.last_name = user.last_name;
      initials.groups = user.groups;
    }
    this.setState({ ...initials, errors: {} });
  }

  handleTextChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value
    });

    if (name === "email") {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(
        function(val: string) {
          this.setState({ errors: checkEmail(this.state.errors, val) });
        }.bind(this, value),
        DEBOUNCETIME
      );
    }
  };

  syncChange = (name: string, val: *) => {
    this.setState({
      [name]: val
    });
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();

    if (Object.keys(this.state.errors).length === 0) {
      this.setState((): * => ({ loading: true }));
      if (this.props.user) {
        this.props.adminUpdateUser(
          this.props.user.uuid,
          this.state.facebase_id,
          this.state.first_name.trim(),
          this.state.last_name.trim(),
          this.state.company_id,
          this.state.email.trim(),
          this.state.groups,
          this.submitDone,
          this.submitFail
        );
      } else {
        this.props.createCompanyUser(
          this.state.facebase_id,
          this.state.first_name.trim(),
          this.state.last_name.trim(),
          this.state.email.trim(),
          this.state.groups,
          this.submitDone,
          this.submitFail,
          this.state.company_id
        );
      }
    }
  };

  submitDone = () => {
    this.props.onClose();
    this.props.openSnackbar(2);
  };

  submitFail = (errors: ErrorsType) => {
    this.setState({ errors: errors, loading: false });
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;

    return (
      <form onSubmit={(!loading && this.submit) || undefined}>
        <Grid container spacing={8}>
          {this.props.isUserAdmin && (
            <Grid item xs={12}>
              <ChipInput
                name="company_id"
                label="Company"
                isStyled
                isRequired
                placeholder="Select a Company"
                tags={this.props.companyList}
                value={this.state.company_id}
                syncChange={this.syncChange}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <ChipInput
              name="facebase_id"
              label="System"
              isStyled
              isRequired
              placeholder="Select a current System"
              tags={this.props.facebaseList}
              value={this.state.facebase_id}
              syncChange={this.syncChange}
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="User Email"
              name="email"
              value={this.state.email}
              onChange={this.handleTextChange}
              inpuType="text"
              isInvalid={this.state.errors.email !== undefined}
            />
          </Grid>
          {this.props.isImagusAdmin && (
            <Grid item xs={12}>
              <ChipInput
                name="groups"
                label="Groups"
                isStyled
                isMultiple
                placeholder="Select Groups"
                tags={this.props.groupList}
                value={this.state.groups}
                syncChange={this.syncChange}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <StyledTextField
              isRequired={false}
              label="First Name"
              name="first_name"
              value={this.state.first_name}
              onChange={this.handleTextChange}
              inpuType="text"
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={false}
              label="Last Name"
              name="last_name"
              value={this.state.last_name}
              onChange={this.handleTextChange}
              inpuType="text"
            />
          </Grid>
          <Grid item xs={12}>
            <ErrosDisplay errors={errors} form="create user" />
          </Grid>
          <Grid item xs={12}>
            <div className="form-right-btn-block">
              <CancelButton onClick={this.props.onClose} />
              <SubmitButton
                loading={loading}
                disabled={Object.keys(errors).length > 0}
              />
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default CreateUserForm;
